module.exports = __webpack_public_path__ + "images/category_lp/jewel/assessment_achievements/6_807fbade93b862824289061694651757.jpg";